import { createApi } from "@reduxjs/toolkit/query/react";
import config from "../config";
import baseQueryWithCorrelationId from "../services/baseQueryWithCorrelationId";
import DocunmentData from "../models/DocunmentData";

const toCsv = (value) => (Array.isArray(value) ? value.join(",") : value);

// Adds a key/value to params only when the value is present.
const withOptional = (params, key, value) => {
    if (value) params[key] = value;
    return params;
};

const buildDocumentsParams = (filters) => {
    const params = {
        documentType: filters.documentType,
        // Contract style is form/explode=false: the array of related org ids
        // rides the query as a comma-joined list.
        isfOrganizationIds: toCsv(filters.isfOrganizationIds),
        isfUserId: filters.isfUserId,
        startPage: filters.startPage,
        count: filters.count,
    };

    withOptional(params, "filterId", filters.filterId);
    withOptional(
        params,
        "policyAndDivisions",
        filters.policyAndDivisions?.length
            ? filters.policyAndDivisions.join(",")
            : undefined
    );
    withOptional(params, "effectiveStartDt", filters.effectiveStartDt);
    withOptional(params, "effectiveEndDt", filters.effectiveEndDt);
    withOptional(params, "sortBy", filters.sortBy);
    withOptional(params, "sortDir", filters.sortDir);

    return params;
};

const documentsApiSlice = createApi({
    reducerPath: "documentsApi",
    baseQuery: baseQueryWithCorrelationId(config.REACT_APP_API_URL),
    endpoints: (builder) => ({
        getDocuments: builder.query({
            query: ({ filters }) => ({
                url: `/reports/${process.env.REACT_APP_API_VERSION}/documents${config.REACT_APP_ENV_NAME}`,
                method: "GET",
                params: buildDocumentsParams(filters),
            }),
            transformResponse: (response) => DocunmentData.format(response),
        }),
        getDocumentById: builder.query({
            keepUnusedDataFor: 0,
            query: ({ documentId, isfOrganizationId, isfUserId }) => ({
                url: `/reports/${process.env.REACT_APP_API_VERSION}/documents/${encodeURIComponent(documentId)}${config.REACT_APP_ENV_NAME}`,
                method: "GET",
                params: {
                    isfOrganizationId,
                    isfUserId,
                },
            }),
        }),
    }),
});

export const { useLazyGetDocumentsQuery, useLazyGetDocumentByIdQuery } =
    documentsApiSlice;
export default documentsApiSlice;
